import type { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { useNavigate } from '@xing-com/crate-core-router';
import { usePageContext } from '@xing-com/crate-entity-pages-entity-pages-shared-context-entity-page-context';
import { IconArrowLeft } from '@xing-com/icons';

import * as Styled from './edit-bar-back.styles';

export const EditBarBack: FC = () => {
  const navigate = useNavigate();
  const { pageContext } = usePageContext();

  return (
    <Styled.TextButton
      size="medium"
      icon={IconArrowLeft}
      onClick={() =>
        navigate(`${pageContext.basePath}/${pageContext.pageSlug}`)
      }
      data-cy="back_to_overview"
    >
      <FormattedMessage id="EP_SUBPAGE_BACK" />
    </Styled.TextButton>
  );
};
